import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import { PrivateRoute } from '@/hooks/useAuth';

const ProjectPage = lazy(() => import('@/containers/Views/Projects/ProjectPage'));
const CreateProjectPage = lazy(() => import('@/containers/Views/Projects/CreateProjectPage'));
const ProjectDetailPage = lazy(() => import('@/containers/Views/Projects/ProjectDetailPage'));
const EditProjectPage = lazy(() => import('@/containers/Views/Projects/EditProjectPage'));

const ProjectRouter = (
  <Route path="projects">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.Projects} 
          permissions={EBasicActions.Find}
        >
          <ProjectPage />
        </PrivateRoute>
      )} 
    />
    <Route 
      path="new" 
      element={(
        <PrivateRoute 
          pageName={EPage.Projects} 
          permissions={EBasicActions.Create}
        >
          <CreateProjectPage />
        </PrivateRoute>
      )}
    />
    <Route 
      path=":projectId" 
      element={(
        <PrivateRoute 
          pageName={EPage.Projects} 
          permissions={EBasicActions.Find}
        >
          <ProjectDetailPage />
        </PrivateRoute>
      )} 
    />
    <Route 
      path=":projectId/edit"
      element={(
        <PrivateRoute 
          pageName={EPage.Projects} 
          permissions={EBasicActions.Edit}
        >
          <EditProjectPage />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default ProjectRouter;
